module.exports = __webpack_public_path__ + "static/media/trailer.9e43ff1d.mp4";